import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";

import { Button, Heading, InputField, Middle, Spacing } from "@otta/design";
import { SendUserEmailVerificationDocument } from "@otta/search/schema";
import { modularScale } from "@otta/design-tokens";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Enter a valid email address")
    .required("Enter your email address")
    .min(5, "Email address must be at least 5 characters"),
});

export function SendEmail() {
  const [sendEmailMutation, { called, loading, error }] = useMutation(
    SendUserEmailVerificationDocument
  );

  const form = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    async onSubmit(values) {
      await sendEmailMutation({ variables: { email: values.email } });
    },
  });

  if (called && !loading && !error) {
    return (
      <Middle style={{ padding: `${modularScale(5)} ${modularScale()}` }}>
        <Spacing>
          <Heading bold size={3} align="center">
            Email sent
          </Heading>
          <p>
            If you have an account with us, you will receive an email with a
            link to verify your email address.
          </p>
        </Spacing>
      </Middle>
    );
  }

  return (
    <Middle style={{ padding: `${modularScale(5)} ${modularScale()}` }}>
      <Spacing>
        <Heading bold size={3} align="center">
          Confirm your email
        </Heading>
        <form onSubmit={form.handleSubmit}>
          <InputField
            name="email"
            type="email"
            label="Email"
            autoFocus
            autoComplete="email"
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            value={form.values.email}
            error={form.touched.email ? form.errors.email : undefined}
            disabled={loading}
          />
          <Button
            type="submit"
            level="primary"
            disabled={loading}
            style={{ marginTop: modularScale(2) }}
          >
            Send verification email
          </Button>
        </form>
      </Spacing>
    </Middle>
  );
}
